import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Featured extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateItems();
    }

    _updateItems() {
        let items = [];
        if (salesChannelRegister.get("market") === "ae") {
            items = [
                {
                    status: "Hairdresser",
                    name: "andrea",
                    text: "Easy to use and instant traffic to my business. I’m very happy with the service as I had no previous experience with paid ads. I’m happy to recommend the service\n"
                },
                {
                    status: "Agent",
                    name: "ali",
                    text: "I was recommended this service from my client, it’s very intuitive and easy to use. I really appreciate the price transparency, I only pay for what I get. All the best!"
                }
            ];
        } else {
            items = [
                {
                    status: langRegister.lang() === "sv" ? "Bilverkstad" : "Car repair shop",
                    name: "anders",
                    text: langRegister.lang() === "sv" ? "Kul tjänst om man snabbt vill komma igång med annonser på nätet. Vi fick en hel del förfrågningar trots en relativt liten budget. Vi har planerat in fler kampanjer " : "Easy service if you want to get started with ads online. We received many inquiries despite a relatively small budget. We have scheduled more campaigns"
                },
                {
                    status: langRegister.lang() === "sv" ? "Städfirma" : "Cleaning company",
                    name: "sara",
                    text: langRegister.lang() === "sv" ? "Vi har provat lite olika konsulter och tjänster men har äntligen hittat rätt – enkelt, snabbt och smart. Man slipper allt onödig trassel och betalar rimliga pengar!" : "We have tried some different consultants and services but have finally found it - easy, fast and smart. Skip all unnecessary hassles and pay reasonable money!"
                }
            ];
        }
        this.setState({items: items});
    }

    _renderText(item) {
        return langRegister.get("signup-image", item);
    }

    render() {
        return (
            <div className={Styles.sectionFifteen}>
                <img className={Styles.sectionThreeShadowTop}
                     src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                <img className={Styles.sectionThreeShadowTopMobile}
                     src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                <div className={Styles.sectionFifteenInner}>
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFifteenImage}
                             src={require("../../assets/images/FeaturedIn_Desktop_SV.png")}/>
                    }
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFifteenImageMobile}
                             src={require("../../assets/images/FeaturedIn_Mobile_SV.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionFifteenImage}
                             src={require("../../assets/images/FeaturedIn_Desktop_EN.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionFifteenImageMobile}
                             src={require("../../assets/images/FeaturedIn_Mobile_EN.png")}/>
                    }
                </div>
                <img className={Styles.sectionFifteenDividerMobile}
                     src={require("../../assets/images/Divider_Mobile.png")}/>
                <img className={Styles.sectionFifteenDivider}
                     src={require("../../assets/images/Divider_Desktop.png")}/>
                <div className={Styles.items}>
                    {
                        this.state.items.map((item) => {
                            return (
                                <div className={Styles.item}>
                                    <div className={Styles.itemBackground}>
                                        <div className={Styles.itemBackgroundOverlay}>
                                            <div className={Styles.itemBackgroundOverlayTop}>
                                                <img className={Styles.itemBackgroundOverlayTopIcon}
                                                     src={require("../../assets/images/AB_client_new.png")}/>
                                                <div className={Styles.itemBackgroundOverlayTopText}>
                                                    <div className={Styles.itemBackgroundOverlayTopStars}>
                                                        <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                             src={require("../../assets/images/star_icon.png")}/>
                                                        <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                             src={require("../../assets/images/star_icon.png")}/>
                                                        <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                             src={require("../../assets/images/star_icon.png")}/>
                                                        <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                             src={require("../../assets/images/star_icon.png")}/>
                                                        <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                             src={require("../../assets/images/star_icon.png")}/>
                                                    </div>
                                                    <div className={Styles.itemBackgroundOverlayTopTextStatus}>
                                                        {item.status}
                                                    </div>
                                                    <div
                                                        className={Styles.itemBackgroundOverlayTopTextName}>
                                                        {item.name}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={Styles.itemBackgroundOverlayBottom}>
                                                {item.text}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <img className={Styles.sectionThreeShadowBottom}
                     src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                <img className={Styles.sectionThreeShadowBottomMobile}
                     src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
            </div>
        );
    }
}

export default Featured;


// WEBPACK FOOTER //
// ./src/components/featured/component.js